import { render, staticRenderFns } from "./CmFrotasChart.vue?vue&type=template&id=23c84c51&"
import script from "./CmFrotasChart.vue?vue&type=script&lang=js&"
export * from "./CmFrotasChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports